import { render, staticRenderFns } from "./PaymentChips.vue?vue&type=template&id=67b450f8&scoped=true"
import script from "./PaymentChips.vue?vue&type=script&lang=js"
export * from "./PaymentChips.vue?vue&type=script&lang=js"
import style0 from "./PaymentChips.vue?vue&type=style&index=0&id=67b450f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b450f8",
  null
  
)

export default component.exports